import { asyncToGenerator as _asyncToGenerator, objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React, { useContext, useRef, useEffect } from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps } from '@mui/material';
import Field from '../Field.js';
import FormContext$1 from '../../../cinnamon-core/es/components/forms/FormContext.js';
import useFormEffect$1 from '../../../cinnamon-core/es/components/forms/useFormEffect.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';
import { fieldFormState, fieldErrors } from '../../../cinnamon-core/es/components/forms/utils.js';

var componentRoot = createComponentSlot({
  name: "CinFormCustomErrors",
  slot: "Root"
});

var CustomErrorsFieldBase = function CustomErrorsFieldBase(_ref) {
  var _formContext$errors;

  var field = _ref.field,
      triggerFields = _ref.triggerFields,
      validator = _ref.validator,
      showErrors = _ref.showErrors,
      allErrors = _ref.allErrors,
      animateErrors = _ref.animateErrors,
      className = _ref.className;
  var formContext = useContext(FormContext$1);
  var mounted = useRef(false);

  var validate = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formState) {
      var validation, errors;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              validation = validator(formState);

              if (!Array.isArray(validation)) {
                _context.next = 5;
                break;
              }

              _context.t0 = validation;
              _context.next = 8;
              break;

            case 5:
              _context.next = 7;
              return validation;

            case 7:
              _context.t0 = _context.sent;

            case 8:
              errors = _context.t0;

              if (mounted.current) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return");

            case 11:
              formContext.onError(field, errors, function (prevErrors) {
                return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, field, errors));
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function validate(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    mounted.current = true;

    if (Array.isArray(triggerFields) && triggerFields.length > 0) {
      // when listening for field changes the validator also needs to run on mount
      var _formState = fieldFormState(formContext);

      validate(_formState);
    }

    return function () {
      mounted.current = false;
    };
  }, []);
  useFormEffect$1(function (formState) {
    validate(formState);
  }, triggerFields);
  var fieldErrors$1 = fieldErrors((_formContext$errors = formContext.errors) === null || _formContext$errors === void 0 ? void 0 : _formContext$errors[field], showErrors !== null && showErrors !== void 0 ? showErrors : formContext.showErrors, allErrors !== null && allErrors !== void 0 ? allErrors : formContext.allErrors);
  return /*#__PURE__*/React.createElement(Field, {
    width: null,
    errors: fieldErrors$1,
    animateErrors: animateErrors !== null && animateErrors !== void 0 ? animateErrors : formContext.animateErrors,
    className: classnames(componentRoot.className, className)
  });
};

CustomErrorsFieldBase.propTypes = {
  field: propTypes.string.isRequired,
  triggerFields: propTypes.arrayOf(propTypes.string),
  validator: propTypes.func.isRequired,
  showErrors: propTypes.bool,
  allErrors: propTypes.bool,
  animateErrors: propTypes.oneOfType([propTypes.number, propTypes.bool]),
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
};
var CustomErrorsFieldRoot = styled(CustomErrorsFieldBase, componentRoot.styledOptions)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: "flex",
    // prevent the bottom margin collapsing when no errors
    ".CinForm-field + &.CinFormCustomErrors-root": {
      marginTop: theme.spacing(-3)
    }
  };
});
/**
 * Displays a collection of errors with custom validation handling
 */

var CustomErrorsField = function CustomErrorsField(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(CustomErrorsFieldRoot, rootProps);
};

var CustomErrorsField$1 = CustomErrorsField;

export { CustomErrorsField$1 as default };
